import { planAutoNI } from '../../../utils/planes'

const env = process.env.NODE_ENV;
const isDevelopment = env === "development";
const setData: boolean = true;

const InitPage: number = 0;
const TotalPage: number = 4;



const AutoDataTemp: IAutoNI = {
    init: false,
    identificationType: '',
    identification: '',
    firstName1: '',
    firstName2: '',
    lastName1: '',
    lastName2: '',
    phoneNumber: '',
    mail: '',
    gender: '',
    civilStatus: '',
    economicActivity: '',
    vehicleUse: '',
    vehicleStatus: '',
    vehicleBrand: '',
    vehicleModel: '',
    vehicleYear: '',
    vehicleColor: '',
    vehicleChassis: '',
    vehicleValue: '',
    vehicleValueStr: '',
    sumAssured: '',
    paymentFrequency: '',
    acceptTerms: false,
    idPlan: planAutoNI,
    saved: false,
    isDatasheet: false,
    policyNumber: 0,
    opportunitySent: false,

    catVehicleBrand: [],
    catVehicleUse: [],
    catVehicleModel: [],
    catVehicleYear: [],
    catPaymentFrequency: [],

    coveragesPlan: {} as ICoveragesPlan,
    datasheet: {} as IDataheet,
    planConfig: {} as IPlanConfig,

    rates:[],
    summary: {} as IRatesResumen
}

const AutoDataTempWithData: IAutoNI = {
    init: false,
    identificationType: '1',
    identification: '570-050591-0000M',
    firstName1: 'Eddy',
    firstName2: 'Antonio',
    lastName1: 'Ortiz',
    lastName2: 'Amador',
    phoneNumber: '8888-8888',
    mail: 'eortiza@lafise.com',
    gender: '1',
    civilStatus: '1',
    economicActivity: '1',
    vehicleUse: '',
    vehicleStatus: '',
    vehicleBrand: '',
    vehicleModel: '',
    vehicleYear: '',
    vehicleColor: 'Blanco',
    vehicleChassis: 'dfd55',
    vehicleValue: '',
    vehicleValueStr: '',
    sumAssured: '',
    paymentFrequency: '1',
    acceptTerms: true,
    idPlan: planAutoNI,
    saved: false,
    isDatasheet: false,
    policyNumber: 0,
    opportunitySent: false,


    catVehicleBrand: [],
    catVehicleUse: [],
    catVehicleModel: [],
    catVehicleYear: [],
    catPaymentFrequency: [],

    coveragesPlan: {} as ICoveragesPlan,
    datasheet: {} as IDataheet,
    planConfig: {} as IPlanConfig,

    rates:[],
    summary: {} as IRatesResumen

}

const setObj = () => (setData && isDevelopment) ? ({ ...AutoDataTempWithData }) : ({ ...AutoDataTemp });

const AutoNIDefault: IAutoNI = setObj();

export { AutoNIDefault, InitPage, TotalPage };